// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
const logoTextSVG = siteData.images_url + 'logo/logo.svg'
const logoTextPNG = siteData.images_url + 'logo/logo.png'

const siteName = siteData.site_name
const siteURL = siteData.site_url
const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class HeaderPrimary extends React.Component {
	render() {
		const { match } = this.props

		return (
			<div className="header">
				<div className="header-top">
					<div className="logo">
						<Link to="/">
							<img className="site-logo" src={ logoTextSVG } data-fallback={ logoTextPNG } alt="" />
						</Link>
					</div>
				</div>
			</div>
		)
	}
}

export default HeaderPrimary
